import React, { useEffect, useRef } from "react";
import useMeasure from "react-use-measure";
import queryString from "query-string";

import { useOptInStore } from "../store";
import App from "../App";

export function AppContainer() {
  const parsed = queryString.parse(location.search);
  const { display } = parsed;

  function ModalWrap() {
    const [ref, { height, width }] = useMeasure();
    const widthRef = useRef(width);
    const [layoutLoaded, setLayoutLoaded] = React.useState(false);
    const setContainer = useOptInStore((state) => state.setContainer);

    useEffect(() => {
      if (width > 0) {
        setContainer(width);
        widthRef.current = width;
      }

      window.parent.postMessage(
        {
          event: "modalSizeChange",
          width,
          height,
        },
        "*"
      );
    }, [width, height]);

    useEffect(() => {
      if (!layoutLoaded) {
        if (width && widthRef.current && width === widthRef.current) {
          setLayoutLoaded(true);
        }
      }
    }, [layoutLoaded, setLayoutLoaded, width, widthRef]);

    return <div ref={ref}>{layoutLoaded && <App />}</div>;
  }

  if (display === "page") {
    return <App />;
  } else {
    return <ModalWrap></ModalWrap>;
  }
}
